<div class="container">
    <h1 jhitranslate="contacts.title"><i class="fa fa-address-card-o fa-pre" aria-hidden="true"></i> Contacts </h1>


    <div class="filters-parent">
        <div class="filters">
            <label class="control-label" for="search">Rechercher</label>
            <input class="form-control input-filter" id="search" type="text" [(ngModel)]="search"
                   placeholder="Filtrer par nom, prénom ou entreprise" #searchInput>
        </div>
    </div>

    <div class="row">
        <div class="col-xs-12 table-responsive">
            <table class="table table-striped table-hover">
                <thead>
                <tr>
                    <th style="min-width: 80px">Titre</th>
                    <th style="min-width: 220px">Nom</th>
                    <th style="min-width: 220px">Prénom</th>
                    <th style="min-width: 300px">Entreprise</th>
                    <th style="width: 100%">Email</th>
                </tr>
                </thead>
                <tbody>
                <tr class="text-center" *ngIf="contacts.length < 1">
                    <td colspan="8">
                        <i class="fa fa-spinner fa-spin fa-fw fa-5x"></i>Chargement de la liste
                    </td>
                </tr>
                <tr *ngFor="let contact of contacts | contactFilterByName:search | contactFilterByActive:displayRemovedContacts"
                    class="session-line" uiSref="contacts-detail"
                    [uiParams]="{ id: contact.id }">
                    <td style="user-select: none">
                        {{contact.title}}
                    </td>
                    <td style="user-select: none">
                        {{contact.firstName}}
                    </td>
                    <td style="user-select: none">
                        {{contact.lastName}}
                    </td>
                    <td style="user-select: none">
                        <div *ngIf="contact.company.length >0">
                            {{contact.company[0].name }}
                        </div>
                        <div *ngIf="contact.company.length < 1">

                        </div>
                    </td>
                    <td style="user-select: none">
                        {{contact.email}}
                    </td>

                </tr>
                </tbody>
            </table>
        </div>
    </div>
    <button class="btn btn-primary btn-round btn-lg" uiSref="contact-create"> +</button>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/directory/contact/contact.component.html